import React, { useState, useRef, useEffect } from "react";
import ToastElement from "../../../Components/UiComponents/ToastElement";
import Loader from "../../../Components/UiComponents/Loader";
import HeaderSearchBar from "../../../Components/UiComponents/HeaderSearch";
import ButtonElement from "../../../Components/UiComponents/ButtonElement";
import DataTable from "../../../Components/UiComponents/DataTable";
import { filter, multiDelete } from "../../../Services/frameworkService";
import { getField } from "../../../Services/tooltipService";
import _ from "lodash";
import Moment from "moment";
import CreateNewProgramme from "./CreateNewProgramme";
import config from "../../../Utils/Constants.json";
import { get } from "../../../Services/customerServices";
import { all as allUsers } from "../../../Services/userService";
import { Dialog } from "primereact/dialog";
import { useNavigate } from 'react-router-dom';
import { useProgramme } from "../../../Providers/ProgrammeContext";
import PlaylistVideos from "../../../Components/Videos/PlaylistVideos";

const Programmes = (props) => {
    const [loading, setLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [frameworkDetails, setFrameworkDetails] = useState([]);
    const [filterFrameworkDetails, setFilterFrameworkDetails] = useState([]);
    const [frameworkDetailsTotal, setFrameworkDetailsTotal] = useState(0);
    const [frameNew, setFrameNew] = useState([]);
    const [moduleName, setModuleName] = useState([]);
    const [commanFieldsNew, setCommanFieldsNew] = useState([]);
    const [frameSummary, setFrameSummary] = useState([]);
    const [frameSection, setFrameSection] = useState([]);
    const [searchedLength, setSearchedLength] = useState(0);
    const [lazyParams, setLazyParams] = useState({
        first: 0,
        rows: 10,
        page: -1,
        sortField: 'framework_name',
        sortOrder: 1
    });
    const [createVisible, setCreateVisible] = useState(false);
    const [currency, setCurrency] = useState('');
    const [regionV1, setRegionV1] = useState([]);
    const [framework, setFramework] = useState([]);
    const [frameworkClassification, setFrameworkClassification] = useState([]);
    const [frameworkSize, setFrameworkSize] = useState([]);
    const [userDetails, setUserDetails] = useState([]);
    const [deleteData, setDeleteData] = useState([]);
    const [deleteProductDialog, setDeleteProductDialog] = useState(false);
    const [moduleNames, setModuleNames] = useState([])
    const [deleteIds, setDeleteIds] = useState([])
    const [customerShortName, setCustomerShortName] = useState('')
    const [deleted, setDeleted] = useState(false)
    const [showVideo, setShowVideo] = useState(false);
    const { setGlobalProgrammeData } = useProgramme();
    const toastRef = useRef();
    const navigate = useNavigate();

    const enduser = localStorage.getItem("enduser");
    if (enduser) {
        var tmpData = JSON.parse(enduser);
        if (tmpData === null) {
            navigate("/login")
            localStorage.clear()
        }
    }

    const userprivileges = localStorage.getItem("user_privileges");
    if (userprivileges) {
        var tmpPrivilege = JSON.parse(userprivileges);
        if (tmpPrivilege !== undefined && tmpPrivilege !== null) {
            var frameworkPrivilege = tmpPrivilege[0].framework_readwrite;
        }
    }

    useEffect(() => {
        setGlobalProgrammeData(null);
    }, [])
    useEffect(() => {
        if (deleted) {
            setDeleted(false);
            setDeleteIds([]);
        }
    }, [deleted])

    useEffect(() => {
        getFrameworkDetails()
        initialgetFields()
        getCustomerDetails()
        getUsers()
    }, [])

    useEffect(() => {
        if (lazyParams) {
            getFrameworkDetails()
        }
    }, [lazyParams])

    useEffect(() => {
        if (props.createVisible && userDetails.length > 0) {
            setCreateVisible(true)
        }
    }, [props.createVisible, userDetails]);

    const handleButtonClick = () => {
        setShowVideo(true);
    };

    const closeVideo = () => {
        setShowVideo(false);
    };

    const getFrameworkDetails = async () => {
        setLoading(true)
        if (tmpData.customer !== null) {
            try {
                const { first, rows, sortField, sortOrder } = lazyParams;
                const skip = first;
                const limit = rows;
                const orderBy = sortOrder;
                const sortBy = sortField;
                const pattern = searchQuery || ''
                var framedetails = await filter(skip, limit, tmpData.customer, pattern, sortBy, orderBy)
                if (framedetails && framedetails.data) {
                    setFrameworkDetails(framedetails.data.framework)
                    setFilterFrameworkDetails(framedetails.data.framework)
                    setFrameworkDetailsTotal(framedetails.data.count)
                }
                setLoading(false)

            } catch (error) {
                toastRef.current.showToast({
                    type: "error",
                    message: "An error occurred. Please try again or contact Admin.",
                });
                setLoading(false)
            }
        }
    }

    const initialgetFields = async () => {
        try {
            setLoading(true)
            var fieldData = await getField(tmpData.customer)
            if (fieldData && fieldData?.data) {
                var clientModuleData = fieldData.data;
                setModuleNames(clientModuleData.cust[0].modules)
                var frameworkModules = _.find(clientModuleData.cust[0].modules, { module_name: "Frameworks", status: true });
                var frameworkModulesClone = frameworkModules.display_name;
                setModuleName(frameworkModulesClone)
                var frameworkFieldsNew = _.find(frameworkModules.sub_modules, { sub_module_name: "NEW" }).fields;
                setFrameNew(frameworkFieldsNew)
                var frameworkSectionsNew = _.find(frameworkModules.sub_modules, { sub_module_name: "NEW" }).sections;
                setFrameSection(frameworkSectionsNew)
                var frameworkSumFields = _.find(frameworkModules.sub_modules, { sub_module_name: "Summary" }).fields;
                setFrameSummary(frameworkSumFields)
                var commonModules = _.find(clientModuleData.cust[0].modules, { module_name: "Common Fields", status: true });
                var commonFields = _.find(commonModules.sub_modules, { sub_module_name: "Common Fields" }).fields;
                setCommanFieldsNew(commonFields);
            }
        } catch (error) {
            toastRef.current.showToast({
                type: "error",
                message: "An error occurred. Please try again or contact Admin.",
            });
        } finally {
            setLoading(false)
        }
    }

    const getCustomerDetails = async () => {
        try {
            setLoading(true)
            if (tmpData) {
                var customerData = await get(tmpData.customer)
                if (customerData && customerData.data) {
                    var currencyData = (!_.isUndefined(customerData.data.currency)) ? customerData.data.currency : '£';
                    setCurrency(currencyData)
                    var customerShort = customerData.data.customer_short;
                    setCustomerShortName(customerShort)
                    var referenceData = customerData.data.reference_data;
                    referenceData.forEach((item) => {
                        if (item.option_names === "RegionV1") {
                            setRegionV1(item.option_choice.filter((option) => option.status === 'active'));
                        } else if (item.option_names === "Framework") {
                            setFramework(item.option_choice.filter((option) => option.status === 'active'));
                        } else if (item.option_names === "FrameworkClassification") {
                            setFrameworkClassification(item.option_choice.filter((option) => option.status === 'active'));
                        } else if (item.option_names === "FrameworkSize") {
                            setFrameworkSize(item.option_choice.filter((option) => option.status === 'active'));
                        }
                    });
                }

            }
        } catch (error) {
            toastRef.current.showToast({
                type: "error",
                message: "An error occurred. Please try again or contact Admin.",
            });
        } finally {
            setLoading(false)
        }
    }

    const getUsers = async () => {
        try {
            if (tmpData) {
                var userData = await allUsers(tmpData.customer, "firstname", 1, tmpData.branch)
                if (userData && userData.data) {
                    setUserDetails(userData.data)
                }
            }
        } catch (error) {
            toastRef.current.showToast({
                type: "error",
                message: "An error occurred. Please try again or contact Admin.",
            });
        } finally {
            setLoading(false)
        }
    }

    const filteredQuestionsArray = (query) => {
        const lowerCaseQuery = query.toLowerCase();
        if (lowerCaseQuery.length === 0) {
            getFrameworkDetails();
            setSearchedLength(lowerCaseQuery.length);
        } else {
            if (lowerCaseQuery.length > searchedLength) {
                setSearchedLength(lowerCaseQuery.length);
            } else {
                setSearchedLength(lowerCaseQuery.length);
            }
            const filteredData = filterFrameworkDetails.filter(item => {
                return Object.values(item).some(value => {
                    if (value != null) {
                        return value.toString().toLowerCase().includes(lowerCaseQuery);
                    }
                });
            });
            setFrameworkDetails(filteredData);
        }
    }

    const handleSearchChange = (e) => {
        setSearchQuery(e);
        setLazyParams({
            ...lazyParams,
            first: 0,
            page: 0
        });
        // filteredQuestionsArray(e.target.value)
    };

    const handleClearFilter = () => {
        setSearchQuery("");
        setLazyParams({
            ...lazyParams,
            first: 0,
            page: 0
        });
        filteredQuestionsArray('')
    };

    const onPage = (event) => {
        setLazyParams({
            ...lazyParams,
            first: event.first,
            rows: event.rows,
            page: event.page,
        });
    };

    const frameworkTemplate = (rowData) => {
        return (
            <div className="form-label-text text-left mr-20 pointer mar-l-5">{rowData.framework_name}</div>
        )
    }

    const reviewTemplate = (rowData) => {
        return rowData.next_review != undefined ? Moment(rowData.next_review).format("DD-MM-YYYY") : ''
    }

    const columns = [
        {
            field: "framework_name",
            header: _.find(frameNew, { field_name: 'Framework' })?.display_name,
            body: frameworkTemplate,
            headerClassName: "header-datatable white-space",
            className: 'row-datatable',
            sortable: true
        },
        {
            field: "framework_label",
            header: _.find(frameNew, { field_name: 'Framework Version Label' })?.display_name,
            headerClassName: "header-datatable white-space",
            className: 'row-datatable',
            sortable: true
        },
        {
            field: "framework_seq",
            header: _.find(frameSummary, { field_name: 'Framework ID' })?.display_name,
            headerClassName: "header-datatable white-space",
            className: 'row-datatable',
            sortable: true
        },
        {
            field: "region",
            header: _.find(commanFieldsNew, { field_name: 'Region' })?.display_name,
            headerClassName: "header-datatable white-space",
            className: 'row-datatable',
            sortable: true
        },
        {
            field: "framework_type",
            header: _.find(frameNew, { field_name: 'Framework Size' })?.display_name,
            headerClassName: "header-datatable white-space",
            className: 'row-datatable',
            sortable: true
        },
        {
            field: "main_board_sponsor",
            header: _.find(commanFieldsNew, { field_name: 'Main Board Sponsor' })?.display_name,
            headerClassName: "header-datatable white-space",
            className: 'row-datatable',
            sortable: true
        },
        {
            field: "maximum_income",
            header: _.find(frameNew, { field_name: 'Maximum Income' })?.display_name,
            headerClassName: "header-datatable white-space",
            className: 'row-datatable',
            sortable: true
        },
        {
            field: "next_review",
            header: _.find(commanFieldsNew, { field_name: 'Next Review' })?.display_name,
            body: reviewTemplate,
            headerClassName: "header-datatable white-space",
            className: 'row-datatable',
            sortable: true
        }
    ]

    const removeField = async (selectedIndex, data) => {
        const ids = [];

        data.forEach(item => {
            ids.push(item._id);
        });
        setDeleteIds(ids)
        setDeleteData(data);
    };

    const rowClick = (rowData) => {
        if (frameworkPrivilege == config[0].readOnly) {
            toastRef.current.showToast({
                type: "error",
                message: 'Permission Denied'
            });
        } else if (frameworkPrivilege == config[1].readWrite) {
            navigate(`/programme/${rowData._id}/${customerShortName}`, {
                state: {
                    frameworkName: rowData.framework_name,
                    framework_id: rowData._id
                }
            });
        }
    }

    const addFramework = () => {
        if (frameworkPrivilege == config[0].readOnly) {
            toastRef.current.showToast({
                type: "error",
                message: 'Permission Denied'
            });
        } else if (frameworkPrivilege == config[1].readWrite) {
            setCreateVisible(true)
        }
    }

    const handleHide = () => {
        setCreateVisible(false);
        getFrameworkDetails()
        if (props.createVisible) {
            props.hidePopUp(false)
        }
    };

    const confirmDeleteProduct = () => {
        setDeleteProductDialog(true);
    };

    const hideDeleteProductDialog = () => {
        setDeleteProductDialog(false);
    };

    const deleteField = async () => {
        try {
            var deleteData = await multiDelete(deleteIds, tmpData.customer)
            if (deleteData && deleteData.data) {
                toastRef.current.showToast({
                    type: "success",
                    message: moduleName + " Deleted Successfully"
                });
                getFrameworkDetails();
                setDeleteProductDialog(false);
                setDeleteData([])
                setDeleted(true)
            }
        } catch (error) {
            toastRef.current.showToast({
                type: "error",
                message: "An error occurred. Please try again or contact Admin.",
            });
        } finally {
            setLoading(false)
        }
    }

    const deleteProductDialogFooter = () => {
        return (
            <div className="cancel-footer">
                <div className='align-center justify-end pb-0'>
                    <ButtonElement label="No" className="cancel-new-button" onClick={hideDeleteProductDialog} />
                    <ButtonElement type="submit" label="Yes" className="save-button" onClick={deleteField} />
                </div>
            </div>
        );
    };

    const onSort = (e) => {
        let newSortField = e.sortField;
        let newSortOrder = e.sortOrder;

        // Check if the same column is clicked
        if (lazyParams.sortField === newSortField) {
            // If currently sorted ascending, switch to descending
            if (lazyParams.sortOrder === 1) {
                newSortOrder = -1; // Set to descending
            }
            // If currently sorted descending, remove sorting
            else if (lazyParams.sortOrder === -1) {
                newSortField = null; // Remove sorting
                newSortOrder = -1; // Remove sorting
            }
        }
        setLazyParams((prevParams) => ({
            ...prevParams,
            sortField: newSortField,
            sortOrder: newSortOrder,
        }));
    };


    return (
        <div className="group-table-component">
            <ToastElement ref={toastRef} />
            <Loader loading={loading} />
            {
                !props.hideDataTable &&
                <div className="group-table-buttons mt-0">
                    <div className="delete-button">
                        {
                            deleteData.length > 0 &&
                            <ButtonElement
                                className="delete-button-icon"
                                type="button"
                                icon="pi pi-trash"
                                onClick={() => confirmDeleteProduct()}
                            />
                        }
                    </div>
                    <div className="group-table-search">
                        <HeaderSearchBar
                            value={searchQuery}
                            onChange={(e) => handleSearchChange(e)}
                            onClick={handleClearFilter}
                        />
                        <ButtonElement
                            className="clear-filter-button"
                            type="button"
                            icon="pi pi-plus"
                            label="New"
                            onClick={addFramework}
                        />
                        <div className="col-md-2 text-right">
                            <ButtonElement className="upload-button" type="button" icon="pi pi-video" onClick={handleButtonClick}></ButtonElement>
                        </div>
                    </div>

                </div>
            }
            {
                !props.hideDataTable &&
                <DataTable
                    dataKey="_id"
                    value={frameworkDetails}
                    columns={columns}
                    searchQuery={searchQuery}
                    rowClick={rowClick}
                    removeField={removeField}
                    lazyParams={lazyParams}
                    totalRecords={frameworkDetailsTotal}
                    onPage={onPage}
                    isPrompts={true}
                    onSort={onSort}
                    deleted={deleted}
                />
            }
            {
                createVisible &&
                <CreateNewProgramme
                    visible={true}
                    frameSection={frameSection}
                    onHide={handleHide}
                    commanFieldsNew={commanFieldsNew}
                    frameNew={frameNew}
                    currency={currency}
                    options={{
                        "regionV1": regionV1,
                        "framework": framework,
                        "frameworkSize": frameworkSize,
                        "frameworkClassification": frameworkClassification,
                        "userDetails": userDetails
                    }}
                    moduleName={moduleName}
                />
            }
            <Dialog visible={deleteProductDialog} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header={`Delete ${_.find(moduleNames, { module_name: "Frameworks" })?.display_name}`} modal footer={deleteProductDialogFooter()} onHide={hideDeleteProductDialog} className="table-dialog width-32" draggable={false}>
                <div className="confirmation-content">
                    <span className="table-description">
                        <span className="table-description">
                            Are you sure to delete {_.find(moduleNames, { module_name: "Frameworks" })?.display_name}?
                        </span>
                    </span>
                </div>
            </Dialog>
            <Dialog id="videoModal" visible={showVideo}
                breakpoints={{
                    '1200px': '80vw',    // Larger modal on bigger screens
                    '1024px': '85vw',    // Slightly smaller for medium screens
                    '769': '90vw',     // Responsive on tablets
                    '641px': '95vw',     // Almost full-width on mobile
                }}
                modal className="table-dialog width-32" draggable={false} width="800px" height="500px" onHide={closeVideo}
            >
                <div className="video-overlay">
                    <div className="video-container">
                        <PlaylistVideos playlistId={process.env.REACT_APP_PROGRAMMES_PLAYLIST_ID} apiKey={process.env.REACT_APP_GOOGLE_API_KEY} module="programme" />
                    </div>
                </div>
            </Dialog>
        </div>
    );
}

export default Programmes